/**
 * What the site's two forms (signup and operator sign-in) genuinely share —
 * extracted rather than re-pasted so the copies cannot drift.
 */

/** The forms are columns of text, and long measures are hard to read. */
export const FORM_MAX_WIDTH = 420;

/**
 * One wording for the whole class of "the request never made it" failures:
 * transport errors, timeouts, and non-4xx surprises alike.
 */
export const CONNECTION_FAILED_MESSAGE =
  "That didn't reach us. Check your connection and try again.";

/**
 * `aria-describedby` and `aria-invalid` both reach the `<input>` —
 * react-native-web forwards them verbatim — but neither appears in the
 * react-native prop types Paper's `TextInput` inherits. Spreading a prepared
 * object is what lets the compiler accept them, and it keeps the workaround in
 * one named place. Same reason `headingProps` is spread rather than written
 * inline.
 */
export function invalidFieldProps(errorMessageId: string) {
  return {
    "aria-invalid": true,
    "aria-describedby": errorMessageId,
  } as const;
}
